<template>
    <div class="transfer-messages">
        <div class="row mb-3 py-2 btn-group-toggle-bg">
            <div class="col mb-1 mb-md-0">
                <div class="btn-group" role="group" v-if="showTransfer && showAnnouncements">
                    <input
                        class="btn-check"
                        type="radio"
                        name="messages"
                        id="messagesAll"
                        autocomplete="off"
                        :checked="filterBy === null"
                    >
                    <label
                        class="btn btn-outline-secondary"
                        for="messagesAll"
                        v-on:click="filterBy = null"
                    >Toon alle</label>
                    <input
                        class="btn-check"
                        type="radio"
                        name="messages"
                        id="messagesTransfer"
                        autocomplete="off"
                        :checked="filterBy === 'nonSticky'"
                    >
                    <label
                        class="btn btn-outline-secondary"
                        for="messagesTransfer"
                        v-on:click="filterBy = 'nonSticky'"
                    >Overdracht</label>
                    <input
                        class="btn-check"
                        type="radio"
                        name="messages"
                        id="messagesNotifications"
                        autocomplete="off"
                        :checked="filterBy === 'sticky'"
                    >
                    <label
                        class="btn btn-outline-secondary"
                        for="messagesNotifications"
                        v-on:click="filterBy = 'sticky'"
                    >Mededelingen</label>
                </div>
            </div>
            <div class="col-auto ms-md-auto">
                <button
                    v-on:click="startNewNote()"
                    class="btn btn-success"
                    type="button"
                >Nieuw bericht</button>
            </div>
        </div>
        <transfer-notes-list
            :notes="filter(notes)"
            :filter-by="noteType"
            :openDialog="showModal"
            @dialogAddTransferNoteShow="onDialogAddShow"
        />
        <div class="row">
            <div class="col text-center">
                <button
                    v-if="isVisible && isLoading"
                    class="btn btn-info btn-load-more"
                    disabled="disabled"
                >
                    <icon name="loading"></icon>
                </button>
                <button
                    v-else-if="isVisible && notes.length > 0"
                    class="btn btn-info btn-load-more"
                    @click="loadMore()"
                >
                    Laad meer
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import TransferNotesList from '@/components/Transfer-Notes-List'
import Icon from '@/components/Icon'

export default {
    name: 'TransferMessages',
    components: {
        TransferNotesList,
        Icon
    },
    watch: {
        notes: {
            handler () {
                this.isLoading = false
                if (this.notes.length < (this.offset + this.limit)) {
                    this.isVisible = false
                } else {
                    this.isVisible = true
                }
            },
            deep: true
        }
    },
    computed: {
        notes () {
            return this.$lodash().sortBy(this.$store.getters.transferNotes, [note => note.date], 'asc').reverse()
        },
        offset () {
            return this.$store.getters.transferNotesOffset
        }
    },
    data () {
        return {
            isVisible: true,
            isLoading: false,
            id: null,
            note: null,
            date: null,
            showModal: false,
            filterBy: null,
            noteType: 'overdracht',
            limitIncrements: 15,
            limit: 15,
            showAnnouncements: false,
            showTransfer: false,
        }
    },
    created () {
        if (this.getApplicationSetting('ipad_announcements') === '1') {
            this.showAnnouncements = true
            this.noteType = 'mededeling'
        }
        if (this.getApplicationSetting('ipad_transfer_notes') === '1') {
            this.showTransfer = true
            this.noteType = 'overdracht'
        }
        if (this.$route.query.type) {
            this.filterBy = this.$route.query.type
        } else if (!this.showAnnouncements || !this.showTransfer) {
            if (this.showAnnouncements) {
                this.filterBy = 'sticky'
            } else if (this.showTransfer) {
                this.filterBy = 'nonSticky'
            }
        } else {
            this.filterBy = null
        }
        this.$store.commit('SET_TRANSFER_NOTES_OFFSET', 0)
        this.getNotes(true)
    },
    methods: {
        startNewNote () {
            this.showModal = true
        },
        onDialogAddShow () {
            this.showModal = false
        },
        setDate (date) {
            this.date = date
        },
        filter (notes) {
            if (this.filterBy === 'sticky') {
                return this.$lodash().filter(this.notes, function (note) {
                    return note.sticky === true
                })
            }
            if (this.filterBy === 'nonSticky') {
                return this.$lodash().filter(this.notes, function (note) {
                    return note.sticky === false
                })
            }
            return notes
        },
        sort (notes) {
            notes = this.$lodash().sortBy(notes, function (dateObj) {
                return new Date(dateObj.date)
            }, ['desc'])
            return notes.reverse()
        },
        isDisabled () {
            return !this.isLoading
        },
        loadMore() {
            this.isLoading = true
            const offset = this.offset + this.limitIncrements
            this.$store.commit('SET_TRANSFER_NOTES_OFFSET', offset)
            this.getNotes()
        },
        getNotes (reset) {
            reset = reset || false
            this.$store.dispatch('getTransferNotes', {
                limit: this.limit,
                offset: this.offset,
                reset: reset
            })
        }
    }
}
</script>

<style scoped>
.btn-load-more {
    margin-top: 15px;
    margin-bottom: 15px;
}

.btn-group-toggle-bg {
    background-color: rgba(0,0,0,.025);
    border-top: 1px solid rgba(0,0,0,.1);
    border-bottom: 1px solid rgba(0,0,0,.1);
}
.btn-group-toggle-bg label {
    margin: 0;
}
.btn-group-toggle-bg .btn-outline-secondary {
    background-color: #fff;
    border-color: rgba(0,0,0,.2);

    &:hover {
        background-color: rgba(0,0,0,.01);
    }
}
.btn-group-toggle-bg .btn-check:checked + .btn {
    color: inherit;
    background-color: rgb(240, 240, 245);
    border-color: rgba(0,0,0,.3);
    box-shadow: none;
}

</style>